module.exports = __webpack_public_path__ + "media/activity-level/puppy-bundle-of-energy-a6402cee.svg";